export default window.globals || {};
